<div class="p-3 pt-2 rounded-4">
    <div>
        <div class="pTitle border-0 mb-0 rounded-bottom-0 rounded-4 p-0">
            <div class="p-3">Customer Limits</div>
        </div>
    </div>
    <div class="container-fluid">
        <div class="row bg-white p-2 pt-0">
            <div class="col-md-12 mt-4 mb-5">
                <div class="table-responsive">
                    <ag-grid-angular style="width: 100%; height: 600px" class="ag-theme-alpine"
                        [columnDefs]="columnDefs" [gridOptions]="gridOptions" (gridReady)="onGridReady($event)">
                    </ag-grid-angular>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #editModal let-modal>
    <div class="modal-header">
        <h4 class="modal-title">Edit Customer Limit</h4>
        <button type="button" class="btn-close" aria-label="Close" (click)="closeModal()"></button>
    </div>
    <div class="modal-body">
        <div class="container-fluid">
            <div class="row pt-2">
                <div class="col-md-12">
                    <div class="mb-3">
                        <label class="form-label">Customer</label>
                        <input type="text" class="form-control" [value]="selectedLimit?.customerId?.name || selectedLimit?.customerId?.emailId" readonly>
                    </div>
                    
                    <div class="mb-3">
                        <label class="form-label">Country</label>
                        <input type="text" class="form-control" [value]="selectedLimit?.countryId?.displayName" readonly>
                    </div>
                    
                    <div class="row">
                        <div class="col-md-6">
                            <div class="mb-3">
                                <label class="form-label">Daily Limit</label>
                                <input type="number" class="form-control" [(ngModel)]="editForm.dailyLimit" min="0">
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="mb-3">
                                <label class="form-label">Monthly Limit</label>
                                <input type="number" class="form-control" [(ngModel)]="editForm.monthlyLimit" min="0">
                            </div>
                        </div>
                    </div>
                    
                    <div class="row">
                        <div class="col-md-6">
                            <div class="mb-3">
                                <label class="form-label">Daily Transaction Limit</label>
                                <input type="number" class="form-control" [(ngModel)]="editForm.dailyTransactionLimit" min="0">
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="mb-3">
                                <label class="form-label">Monthly Transaction Limit</label>
                                <input type="number" class="form-control" [(ngModel)]="editForm.monthlyTransactionLimit" min="0">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="closeModal()">Cancel</button>
        <button type="button" class="btn btn-primary" (click)="updateLimit()" [disabled]="!isFormValid()">Update</button>
    </div>
</ng-template>